module.exports = __webpack_public_path__ + "static/Toyota-Etios-liva-766cac69d7e532dca5e949de3412be19.png";